export { filter, check, propType } from './utilities';
import { graphql } from './graphql';
export default graphql;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/graphql-anywhere/lib/index.js
// module id = 601
// module chunks = 0